export default function chunkArray(array, chunkSize) {
  return array.reduce((chunks, item, i) => {
    const chunk = Math.floor(i / chunkSize);
    chunks[chunk] = [].concat((chunks[chunk] || []), item);
    return chunks;
  }, []);
}
